import { render, staticRenderFns } from "./AnnouncementAction.vue?vue&type=template&id=6ecdc910&scoped=true"
import script from "./AnnouncementAction.vue?vue&type=script&lang=js"
export * from "./AnnouncementAction.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementAction.vue?vue&type=style&index=0&id=6ecdc910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecdc910",
  null
  
)

export default component.exports